// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const ComponentReviewCarouselFragmentDoc = gql`
    fragment componentReviewCarousel on ComponentReviewCarousel {
  reviews {
    author
    date
    review
    starsCount
  }
}
    `;